<div class="container" [class.container--loading]="loading">
  @if (loading) {
    <div class="loading-overlay" role="status" aria-live="polite">
      <span class="sr-only">{{ 'COMMON.LAYOUT.LOADING' | translate }}</span>
      <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>
    </div>
  }

  <div class="header">
    <div class="logo">
      <app-company-logo></app-company-logo>
    </div>

    <button
      type="button"
      class="simple-close-button"
      (click)="close(false)"
      [disabled]="loading"
      [attr.aria-label]="'MFA_INFO_MODAL.CLOSE' | translate">
      <mat-icon class="close-icon" aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="message" [innerHTML]="'MFA_INFO_MODAL.INFO_MESSAGE' | translate"></div>
    <div class="do-not-show-again">
      <mat-checkbox
        color="primary"
        [checked]="stopMfaInfoWindow"
        [disabled]="loading"
        (change)="changeStopMfaInfoWindow($event.checked)">
        {{ 'MFA_INFO_MODAL.DO_NOT_SHOW_AGAIN' | translate }}
      </mat-checkbox>
    </div>
  </div>

  <div class="footer">
    <button type="button" mat-raised-button class="close-button" (click)="close(false)" [disabled]="loading">
      {{ 'MFA_INFO_MODAL.CLOSE' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      class="go-to-settings-button"
      (click)="close(true)"
      [disabled]="loading">
      {{ 'MFA_INFO_MODAL.GO_TO_SETTINGS' | translate }}
    </button>
  </div>
</div>
